import { render, staticRenderFns } from "./TheOracleAccountModuleRoleForm.vue?vue&type=template&id=689c20e4&"
import script from "./TheOracleAccountModuleRoleForm.vue?vue&type=script&lang=js&"
export * from "./TheOracleAccountModuleRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports